export default "__VITE_ASSET__b26366c4__"